import { AddIcon } from '@approvalmax/ui';
import { Box, Button, Grid, Table, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { useAddressTable } from './AddressLinesInformation.hooks';
import { messages } from './AddressLinesInformation.messages';

export const AddressLinesInformation = memo(() => {
    const { handleRowAdd, columnData, columns, rowActionMenuItems } = useAddressTable();

    return (
        <>
            <Text font='headline' fontSize='xxsmall' fontWeight='medium' color='midnight80' spacing='20 0'>
                {messages.addressesSection}
            </Text>

            <div>
                <Grid gridTemplateColumns='100%' overflowX='auto'>
                    <Table columns={columns} data={columnData} bordered rowActionMenuItems={rowActionMenuItems} />
                </Grid>

                <Box spacing='8 0'>
                    <Button size='small' color='blue80' onClick={handleRowAdd} startIcon={<AddIcon />}>
                        {messages.addLineButtonText}
                    </Button>
                </Box>
            </div>
        </>
    );
});

AddressLinesInformation.displayName = 'AddressLinesInformation';
